"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAuthSession = void 0;
// `fetchAuthSession` is the overloaded top-level API: `fetchAuthSession(options?)`
// resolves the global AmplifyContext, while `fetchAuthSession(ctx, options?)`
// uses the explicitly-passed (e.g. per-request SSR) context — restoring the
// pre-context v6 SSR calling pattern `fetchAuthSession(contextSpec)`.
var singleton_1 = require("./singleton");
Object.defineProperty(exports, "fetchAuthSession", { enumerable: true, get: function () { return singleton_1.fetchAuthSession; } });
